import { render, staticRenderFns } from "./SideNavSave.vue?vue&type=template&id=370d60a9&"
import script from "./SideNavSave.vue?vue&type=script&lang=js&"
export * from "./SideNavSave.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports